import { NormalButton } from '@/shared/ui/components';
import { DOUBLE_HYPHEN_BULLET } from '@/shared/config';
import { t } from 'ttag';
import HighSamplingRate from '../highSamplingRate/highSamplingRate';
import './deviceIdFormatter.scss';
import type { DeviceIdFormatterProps } from './deviceIdFormatter.types';

/**
 * Empty stand-in for an absent device id click callback. Does nothing when invoked.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

/**
 * Device id cell showing the id alongside the device's state tags. Destructures the props with defaults, rendering a double-hyphen placeholder for the all-zero device id and otherwise a text button firing the click handler, followed by the high-sampling-rate marker and the RMA, Renewal, In Study and EOL labels for whichever flags are set.
 *
 * @param props - Device id, click handler and the RMA, renewal, in-study, end-of-life and sampling-rate flags.
 * @returns The device id cell element.
 */
const DeviceIdFormatter = (props: DeviceIdFormatterProps) => {
  const {
    deviceId = '',
    rma = false,
    handleClickDeviceId = NOOP,
    isEOL = false,
    isHighSamplingRate = false,
    isRunningStudy = false,
    isRenewal = false,
  } = props;

  return (
    <div className="flex items-center no-wrap flex-wrap">
      <div>
        {deviceId === '0000000000' ? (
          <span>{DOUBLE_HYPHEN_BULLET}</span>
        ) : (
          <NormalButton
            id="device-id-btn"
            className="nowrap"
            isText
            buttonName={deviceId}
            onClick={handleClickDeviceId}
          />
        )}
      </div>
      {isHighSamplingRate && <HighSamplingRate hasTooltip />}
      {rma && <span className="rma-label ml2">{t`RMA`}</span>}
      {isRenewal && <span className="renewal-label ml2">{t`Renewal`}</span>}
      {isRunningStudy && <span className="in-study-label ml2">{t`In Study`}</span>}
      {isEOL && <span className="rma-label ml2">{t`EOL`}</span>}
    </div>
  );
};

export default DeviceIdFormatter;
